export default __webpack_public_path__ + "static/media/chooseLangModalBC5.2d816035.png";